package com.ervasstudio.tracoemovimento.components.custumcomponents.layout

import androidx.compose.runtime.*
import com.ervasstudio.tracoemovimento.model.GoogleUser
import com.ervasstudio.tracoemovimento.util.GoogleSignInResult
import com.ervasstudio.tracoemovimento.util.Res.Image.glogo
import com.ervasstudio.tracoemovimento.util.mapFirebaseError
import com.ervasstudio.tracoemovimento.util.signInWithGoogle
import com.huanshankeji.compose.html.material3.MdCircularProgress
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px

@Composable
fun GoogleLoginButton(
    onSuccess: (user: GoogleUser) -> Unit,
    onError: (erro: String) -> Unit
) {
    val coroutineScope = rememberCoroutineScope()
    var isLoading by remember { mutableStateOf(false) }
    var errorMessage by remember { mutableStateOf<String?>(null) }

    Button(
        onClick = {
            if (isLoading) return@Button
            isLoading = true

            coroutineScope.launch {
                when (val result = signInWithGoogle()) {
                    is GoogleSignInResult.Success -> {
                        val user = result.user
                        onSuccess(user)
                        // navega para /cursos/meuscursos, atualiza o teu AuthViewModel/StateFlow, etc.
                    }
                    is GoogleSignInResult.Error -> {
                        errorMessage = mapFirebaseError(result.code)
                        onError(mapFirebaseError(result.code))
                    }
                }
                isLoading = false
            }
        },
        enabled = !isLoading,


    ) {
        if(!isLoading){
            Image(
                src = glogo,
                alt = "Google",
                modifier = Modifier.width(32.px)
            )

        }
        else{
            MdCircularProgress(indeterminate = true)
        }
    }

    errorMessage?.let {
        SpanText(it, Modifier.color(Colors.Red))
    }
}